import React from 'react'
import { FaBox, FaHome, FaKey, FaPlusCircle, FaUser } from 'react-icons/fa'

import FooterItem from './Item'
const Footer: React.FC = () => {
  return <div className='flex flex-row justify-evenly items-center h-14 w-full border-t rounded-t-lg bg-white pt-1 '>
      <FooterItem to="/" icon={FaHome} label="Home" />
      <FooterItem to="/rentVehicle" icon={FaKey} label="RentVehicle" />
      <FooterItem to="/addVehicle" icon={FaPlusCircle} label="Add Vehicle" />
      <FooterItem to="/package" icon={FaBox} label="Packages" />
      <FooterItem to="/account" icon={FaUser} label="Account" />
    </div>
}

export default Footer
